const styles = (theme) => ({
  root: {
    width: '100%',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    alignItems: 'flex-start',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      paddingRight: 48,
    },
    marginLeft: '-5px',
  },
  restrictHeader: {
    maxHeight: 50,
    [theme.breakpoints.up('md')]: {
      maxHeight: 'none',
    },
  },
  actionHeader: {
    cursor: 'pointer',
  },
  title: {
    width: '100%',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    marginTop: theme.spacing.unit,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing.unit * 2,
    },
  },
  avatar: {
    color: '#ffffff',
    padding: theme.spacing.unit,
    paddingBottom: theme.spacing.unit / 2,
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2 - theme.spacing.unit / 2,
      marginTop: -theme.spacing.unit * 3,
      marginRight: theme.spacing.unit * 3,
    },
  },
  appointments: {
    color: theme.palette.custom.appointments,
  },
  workRequests: {
    color: theme.palette.custom.maintenance,
  },
  accounts: {
    color: theme.palette.custom.accounts,
  },
  action: {
    color: theme.palette.primary.dark,
    cursor: 'pointer',
    border: `1px solid #007749`,
    borderRadius: 5,
    marginTop: theme.spacing.unit * 2,
    marginRight: -theme.spacing.unit,
    alignSelf: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing.unit * 1,
      marginRight: -theme.spacing.unit * 0.75,
    },
  },
});

export default styles;
